import { render, staticRenderFns } from "./AccountAdmin.vue?vue&type=template&id=3a275ac8&"
import script from "./AccountAdmin.vue?vue&type=script&lang=js&"
export * from "./AccountAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports